import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';

import { ResidentService } from '../../resident-details/resident.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';
import { VillageStaffService } from '../village-staff.service';
import { AdminService } from 'src/app/admin/admin.service';
import * as moment from 'moment';

@Component({
  selector: 'app-add-permit',
  templateUrl: './add-permit.component.html',
  styleUrls: ['./add-permit.component.scss']
})
export class AddPermitComponent implements OnInit {
  addPermitForm: FormGroup;
  public showSpinner: boolean = false;
  public address;
  public streets = [];
  public streetNumber = [];
  public states: any;
  //public reasons = [];
  public maxDate;
  public todayDate = new Date();
  public selectedState: any
  public streetNumbers: any;
  public years: any;
  private currentUserId: any;
  btndisabled: boolean = false;


  public months = [
    { val: '0', name: 'Jan' },
    { val: '01', name: 'Feb' },
    { val: '02', name: 'Mar' },
    { val: '03', name: 'Apr' },
    { val: '04', name: 'May' },
    { val: '05', name: 'Jun' },
    { val: '06', name: 'Jul' },
    { val: '07', name: 'Aug' },
    { val: '08', name: 'Sep' },
    { val: '09', name: 'Oct' },
    { val: '10', name: 'Nov' },
    { val: '11', name: 'Dec' }
  ];
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;

  constructor(private formBuilder: FormBuilder,
    private adminService: AdminService,
    private residentService: ResidentService,
    private villageStaffService: VillageStaffService,
    public snackBar: MatSnackBar,
    private vovSharedService: vovSharedService) {
  }

  ngOnInit(): void {
    this.addPermitForm = this.formBuilder.group({
      stateId: ['', Validators.required],
      year: ['', Validators.required],
      month: ['', Validators.required],
      plateNo: ['', Validators.required]
    })

    this.reset();
    this.vovSharedService.fetchAllStreets().subscribe((res) => {
      this.streets = res.streetsList;
      this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });


    this.vovSharedService.fetchAllStates().subscribe((res) => {
      this.states = res.statesList;
      const toSelect = this.states.sort((a, b) => a.state.localeCompare(b.state)).filter(s => s.state == 'IL')
      if (toSelect) {
        this.addPermitForm.get("stateId").patchValue(toSelect[0].id);
      }
      let temStates = res.statesList;
      let result = [];
      result.push(temStates.find(f => f.state == 'IL'));
      result.push(temStates.find(f => f.state == 'WI'));
      temStates = temStates.filter(f => f.state != 'IL' && f.state != 'WI');
      temStates.forEach(element => {
        result.push(element)
      });
      this.states = result;

    });




    this.adminService.getYearCycle().subscribe(res => {
      if (res && res.yearsList && res.yearsList.length) {
        const arr = [];
        res.yearsList.forEach((year) => {
          arr.push(year.year);
        })
        this.years = arr.sort((a, b) => a - b);


      }
    });

    this.addPermitForm.controls['plateNo'].valueChanges.subscribe(
      (value) => { if (value) this.btndisabled = false })

    const currentUser = localStorage.getItem("currentUser");
    this.currentUserId = JSON.parse(currentUser).id;
  }

  onSubmit() {
    this.btndisabled = true;
    console.log(this.addPermitForm.value);
    this.addPermitForm.value['userId'] = this.currentUserId;
    this.villageStaffService.createParkingPermit(this.addPermitForm.value).subscribe(res => {
      console.log('res')
      if (res.Permit == 'Successfully') {
        this.formGroupDirective.resetForm();
        this.addPermitForm.reset();
        this.snackBar.open('Success :' + 'Parking permit successfully added.', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
      } else if (res.message == 'Already Exist Permit') {
        this.formGroupDirective.resetForm();
        this.addPermitForm.reset();
        this.snackBar.open('warning :' + 'Parking permit already exist.', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
      } else if (res.message == 'Please select valid month') {
        this.snackBar.open('warning :' + 'Please select valid month', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
      }

    })
  }

  reset() {
    this.addPermitForm.reset();
  }

  getAddress() {
    this.showSpinner = true;
    this.adminService.getAddressDetail().subscribe(res => {
      console.log(res);
      this.showSpinner = false;
      if (res.result.length > 0) {
        this.address = res.result;
      }
      let street = this.address.map(res => res.street.toLowerCase());
      this.streets = street.filter((data, index) => street.indexOf(data) == index)
    })
  }

}
